import type { PaytreeMethodId } from "./paytree";

/**
 * Which PayTree methods are offered for NEW payments — a subset of
 * PAYTREE_METHODS in `./paytree`, which reads it through
 * `getActivePaytreeMethods`.
 *
 * Empty: PayTree offers no new payment. PayPal was removed as a payment method
 * at the owner's request (2026-11-04), card/Stripe/Airwallex remain paused and
 * Klarna is not offered. With no active method the PayTree rail stays closed;
 * Vorkasse (and crypto, where its rail is open) carry the checkout.
 *
 * This allow-list governs both the checkout tiles and new server-side starts; a
 * rail preview cannot widen it. The catalogue itself (`isPayTreeMethod`) keeps
 * recognizing every method, so payments started earlier, PayPal included,
 * still return, settle and reconcile. Re-activating a method needs its
 * checkout translations, a build and a deployment.
 *
 * A module of its own so suites that keep the start contract covered for a
 * re-activation can mock it; `paytree-checkout-pause.test.ts` and
 * `paytree.test.ts` check the real value.
 */
export const PAYTREE_ACTIVE_METHOD_IDS: readonly PaytreeMethodId[] = [];
